import { useTranslation } from "react-i18next";
import { FormControlLabel, Radio, RadioGroup } from "@mui/material";
import PgxHeader from "../../pgx/PgxHeader";

const PgxInit = ({ pgxExists, onChangePgxExists, newPgx, setNewPgx }) => {
  const {t} = useTranslation();

  return (<>
    <div className="w3-container form-content">
      <RadioGroup aria-labelledby="pgx-exits-group" name="pgx-exits-group" value={pgxExists} defaultValue={pgxExists}
                  onChange={(e) => onChangePgxExists(e.target.value)}>
        <div className="w3-row">
          <FormControlLabel value="yes" control={<Radio />} label={<label>{t("yes")}</label>} />
          <FormControlLabel value="not" control={<Radio />} label={<label>{t("not_yet")}</label>} />
          <FormControlLabel value="waiting" control={<Radio />} label={<label>{t("i_am_waiting")}</label>} />
        </div>
      </RadioGroup>
    </div>
    {pgxExists === "yes" &&
      <PgxHeader newPgx={newPgx} setNewPgx={setNewPgx} init={true} createNewDialogOpened={ true } />
    }
  </>);
};

export default PgxInit;
